import {
  combineReducers,
  createStore,
  compose,
  applyMiddleware,
  Store,
} from 'redux';
import { routeReducer, syncHistory } from 'react-router-redux';
import { browserHistory } from 'react-router';
import thunk from 'redux-thunk';
import { forms, FormState } from '../reducers';
import { createLogger } from 'redux-logger';
import {
  SignGridComponentReducer,
  SignGridComponentReducerStateInterface,
} from '../components/controls/SignGridComponent/reducer';
export type RootState = {
  routing: any;
  forms: FormState;
  SignGridComponentReducer: SignGridComponentReducerStateInterface;
};

const logger = createLogger();
const reduxRouterMiddleware = syncHistory(browserHistory);
const rootReducer = combineReducers<RootState>({
  routing: routeReducer,
  forms: forms,
  SignGridComponentReducer: SignGridComponentReducer,
});

let store: Store<RootState>;

if (process.env.NODE_ENV === 'production') {
  store = createStore(
    rootReducer,
    // @ts-ignore
    compose(applyMiddleware(thunk, reduxRouterMiddleware)),
  );
} else {
  store = createStore(
    rootReducer,
    // @ts-ignore
    compose(applyMiddleware(thunk, reduxRouterMiddleware)),
  ); //, logger

  // @ts-ignore
  // window._store = store;
}

export { store };
